// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Trasladado ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'La acción ' + p['label'] + ' ha terminado',
  accButtonProgressStatus: (p: { label: string }) => 'Acción ' + p['label'] + ' en curso',
  accColorPalette: () => 'Paleta de Colores',
  accColorSwatch: () => 'Muestra de color',
  accCommandKey: () => 'Comando',
  accContextMenuLabel: () => 'acciones',
  accControlKey: () => 'Cerrar',
  accPositionAfter: () => 'posterior',
  accPositionBefore: () => 'anterior',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Mantenga pulsadas las teclas ' +
    p['keyPressed'] +
    ' y Mayúsculas, y utilice las teclas de flecha para reordenar.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Introduzca una fecha completa como la siguiente: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Introduzca un mes completo como el siguiente: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Etiqueta',
  chart_labelGroup: () => 'Grupo',
  chart_labelSeries: () => 'Serie',
  chart_labelValue: () => 'Valor',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Seleccione un valor.',
  checkbox_helpForCheckbox: () => 'Ayuda para casilla de control',
  checkbox_requiredMessageDetail: () => 'Seleccione un valor.',
  checkbox_selected: () => 'Casilla de control activada',
  checkbox_unselected: () => 'Casilla de control no activada',
  close: () => 'Cerrar',
  collection_apply: () => 'Aplicar',
  collection_cancel: () => 'Cancelar',
  collection_loaded: () => 'Cargado',
  collection_loading: () => 'Cargando',
  collection_noData: () => 'No hay datos que mostrar.',
  collection_pixels: () => 'px',
  collection_resizeColumnDialog: () => 'Cambiar tamaño de columna',
  collection_resizeColumnMenu: () => 'Cambiar Tamaño de Columna...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Introduzca un número entre ' + p['MIN'] + ' y ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Seleccione todas las filas',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Seleccione la fila ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Ascendente',
  collection_sortColumnMenu: () => 'Columna de Ordenación',
  collection_sortDescendingSubMenu: () => 'Descendente',
  collection_sortDisabled: () => 'No se puede ordenar',
  collection_sortEnabled: () => 'Se puede ordenar',
  collection_width: () => 'Ancho',
  colorPicker_label: () => 'Selector de color',
  confirmation: () => 'Confirmación',
  datePicker_currentDate: () => 'Fecha actual',
  datePicker_goToToday: () => 'Ir a Hoy',
  datePicker_label: () => 'Selector de fecha',
  datePicker_month: () => 'Mes',
  datePicker_months: () => 'Meses',
  datePicker_next: () => 'Siguiente',
  datePicker_nextDecade: () => 'Década siguiente',
  datePicker_nextMonth: () => 'Mes próximo',
  datePicker_prev: () => 'Anterior',
  datePicker_prevDecade: () => 'Década anterior',
  datePicker_prevMonth: () => 'Mes anterior',
  datePicker_restricted: () => 'Con restricciones',
  datePicker_selected: () => 'Seleccionado',
  datePicker_today: () => 'Hoy',
  datePicker_weekNum: (p: { NUM: string }) => 'Semana ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Número de semana',
  datePicker_year: () => 'Año',
  datePicker_years: () => 'Años',
  diagram_promotedLink: () => '1 enlace',
  diagram_promotedLinkAriaDesc: () => 'Indirecto',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' enlaces',
  error: () => 'Error',
  expandableList_expandCollapseInstructionText: () =>
    'Utilice las teclas de flecha para ampliar y reducir',
  expandableList_groupCollapse: () => 'Reducido',
  expandableList_groupExpand: () => 'Ampliado',
  filePicker_addFiles: () => 'Agregar archivos',
  filePicker_dropzonePrimaryText: () => 'Arrastrar y Soltar',
  filePicker_dropzoneSecondaryText: () => 'Seleccione un archivo o suelte uno aquí',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Seleccione o suelte archivos aquí',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'No puede cargar archivos del tipo: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Cargue los archivos de uno en uno',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'No puede cargar archivos del tipo ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'desconocido',
  formControl_clear: () => 'Borrar',
  formControl_day: () => 'Día',
  formControl_empty_segment: () => 'Vaciar',
  formControl_helpAvailable: () => 'Ayuda disponible',
  formControl_hide: () => 'Ocultar',
  formControl_hour: () => 'Hora',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Ha alcanzado el límite de ' +
    ((
      {
        one: new Intl.NumberFormat('es').format(p['CHARACTER_LIMIT']) + ' carácter',
        many: new Intl.NumberFormat('es').format(p['CHARACTER_LIMIT']) + ' de caracteres'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('es').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('es').format(p['CHARACTER_LIMIT']) + ' caracteres') +
    '.',
  formControl_loading: () => 'Cargando',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Puede introducir hasta ' + p['MAX_LENGTH'] + ' caracteres.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Longitud máxima ' + p['MAX_LENGTH'] + ' superada.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Quedan ' + p['CHARACTER_COUNT'] + ' caracteres.',
  formControl_millisecond: () => 'Milisegundo',
  formControl_minute: () => 'Minuto',
  formControl_month: () => 'Mes',
  formControl_readOnly: () => 'Solo lectura',
  formControl_requiredMessageDetail: () => 'Introduzca un valor.',
  formControl_second: () => 'Segundo',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Seleccionar ' + p['n'] + ' valores.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Ha alcanzado el límite de selección de ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Seleccione entre ' + p['min'] + ' y ' + p['max'] + ' valores.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Seleccione al menos ' + p['min'] + ' valores.',
  formControl_show: () => 'Mostrar',
  formControl_year: () => 'Año',
  gantt_labelDate: () => 'Fecha',
  gantt_labelEnd: () => 'Fin',
  gantt_labelLabel: () => 'Etiqueta',
  gantt_labelRow: () => 'Fila',
  gantt_labelStart: () => 'Inicio',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. No se ha encontrado ninguna sección que coincida.',
  indexer_keyboardInstructionText: () => 'Entre para seleccionar valor.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' y ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Toque dos veces y mantenga pulsado para cambiar a modo de gestos y, a continuación, arrastre hacia arriba o hacia abajo para ajustar el valor.',
  info: () => 'Información',
  inputColor_selectColor: () => 'Seleccionar color',
  inputDateMask_date_cleared: () => 'Fecha borrada',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Vaciar',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduzca una fecha igual o anterior a ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduzca una fecha igual o posterior a ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Introduzca una fecha disponible.',
  inputDatePicker_instruction: () => 'Pulse el tabulador para acceder al calendario.',
  inputDatePicker_selectDate: () => 'Seleccionar Fecha',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduzca un valor de mes y año igual o anterior a ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduzca un valor de mes y año igual o posterior a ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Introduzca un número.',
  inputNumber_decrease: () => 'Disminuir',
  inputNumber_increase: () => 'Aumentar',
  inputPassword_hidden: () => 'Contraseña oculta',
  inputPassword_hide: () => 'Ocultar contraseña',
  inputPassword_show: () => 'Mostrar Contraseña',
  inputSensitiveText_hidden: () => 'Texto confidencial oculto',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Introduzca una hora igual o anterior a ' + p['max'] + '.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Introduzca una hora igual o posterior a ' + p['min'] + '.',
  inputTimeMask_time_cleared: () => 'Tiempo limpiado',
  labelNone: () => 'Ninguno',
  list_msgFetchCompleted: () => 'Cargado',
  list_msgFetchingData: () => 'Cargando',
  list_suggestion: () => 'Sugerencia',
  menu_stateLoading: () => 'Cargando',
  messageToast_allMessagesClosed: () =>
    'Se han cerrado todos los mensajes de notificación del sistema.',
  message_close: () => 'Cerrar',
  message_confirmation: () => 'Correcto',
  message_error: () => 'Error',
  message_info: () => 'Información',
  message_navigationFromMessagesRegion: () =>
    'Introducción de la región de mensajes. Pulse F6 para navegar.',
  message_navigationToMessagesRegion: () =>
    'La zona de mensajes tiene mensajes nuevos. Pulse F6 para navegar a ella.',
  message_navigationToTouch: () => 'La zona de mensajes tiene mensajes nuevos',
  message_warning: () => 'Advertencia',
  noData_message: () => 'No hay elementos para mostrar',
  overflowItemLabel: () => 'Más separadores',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Toque dos veces para cerrar la ventana emergente abierta.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Ventana emergente de entrada. Pulse F6 para cambiar entre la ventana emergente y el control asociado.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Ventana emergente abierta. Pulse F6 para cambiar entre la ventana emergente y el control asociado.',
  progressIndeterminate: () => 'En curso',
  radioButton_checked: () => 'Botón de radio activado',
  radioButton_selected: () => 'Botón de radio seleccionado',
  radioButton_unchecked: () => 'Botón de radio no activado',
  radioButton_unselected: () => 'Botón de radio no seleccionado',
  radio_helpForRadio: () => 'Ayuda para botón de radio',
  radio_requiredMessageDetail: () => 'Seleccione un valor.',
  selectMultiple_apply: () => 'Aplicar',
  selectMultiple_back: () => 'Atrás',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Utilice las teclas de flecha izquierda y derecha para destacar los valores seleccionados.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pulse Retroceso o Suprimir para eliminar el valor seleccionado.',
  selectMultiple_selectedValues: () => 'Valores seleccionados',
  selectMultiple_showSelectedValues: () => 'Solo se muestran los valores seleccionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores seleccionados.',
  select_addToList: () => 'Agregar a la Lista',
  select_addToListAvailable: () => 'Agregar a la lista disponible',
  select_closeDropdown: () => 'Pulse Escape para cerrar.',
  select_moreSearchOptions: () => 'Más opciones de búsqueda',
  select_moreSearchOptionsAvailable: () => 'Más opciones de búsqueda disponibles',
  select_noMatchesFound: () => 'No se ha encontrado ninguna coincidencia.',
  select_oneMatchFound: () => 'Se ha encontrado una coincidencia',
  select_requiredMessageDetail: () => 'Seleccione un valor.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Se han encontrado ' + p['TOTAL_SIZE'] + ' coincidencias',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Se han encontrado ' + p['TOTAL_SIZE'] + ' coincidencias o más',
  selectorAll_deselectAll: () => 'Anular selección de todo',
  selectorAll_selectAll: () => 'Seleccionar todo',
  selector_selected: () => 'Casilla de control activada',
  selector_unselected: () => 'Casilla de control no activada',
  sheet_close: () => 'Cerrar',
  switch_off: () => 'Desactivado',
  switch_on: () => 'Activado',
  tabBarNavigationList_removeCueText: () => 'Se puede eliminar',
  tabBar_tabContainsErrors: () => 'Contiene errores',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Se eliminó ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'tiene menú contextual',
  tabbar_labelMoveLeft: () => 'Mover a la izquierda',
  tabbar_labelMoveRight: () => 'Mover a la derecha',
  tabbar_labelRemove: () => 'Eliminar',
  timeComponent_tooltipZoomIn: () => 'Ampliar',
  timeComponent_tooltipZoomOut: () => 'Reducir',
  timeConverter_parseError: () => 'Introduzca una hora de finalización.',
  train_current: () => 'Actual',
  train_message_type: () => 'Tipo de Mensaje',
  train_not_visited: () => 'No visitado',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Paso ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_visited: () => 'Visitado',
  userAssistance_learnMore: () => 'Más información',
  userAssistance_required: () => 'Necesaria',
  vis_clearSelection: () => 'Borrar Selección',
  vis_drillable: () => 'Explorable',
  vis_invalidData: () => 'Datos no válidos',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' de ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Selección de Marquesina',
  vis_marqueeZoomTooltip: () => 'Zoom con Marquesina',
  vis_noData: () => 'No hay datos que mostrar',
  vis_panTooltip: () => 'Panorámica',
  vis_stateCollapsed: () => 'Reducido',
  vis_stateExpanded: () => 'Ampliado',
  vis_stateLoaded: () => 'Cargado',
  vis_stateLoading: () => 'Cargando',
  vis_stateSelected: () => 'Seleccionado',
  vis_stateUnselected: () => 'No seleccionado',
  warn: () => 'Advertencia'
};
export default bundle;
